var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShapes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "232px",
    height: "237px",
    viewBox: "0 0 232 237",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.188,80.594 C161.188,125.104 125.105,161.187 80.594,161.187 C36.083,161.187 -2.84217094e-14,125.104 -2.84217094e-14,80.594 C-2.84217094e-14,36.083 36.083,0 80.594,0 C125.105,0 161.188,36.083 161.188,80.594",
    id: "path-fx7mjjbv2s-1"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "63.1786673%",
    cy: "36.3469507%",
    fx: "63.1786673%",
    fy: "36.3469507%",
    r: "59.4601788%",
    gradientTransform: "translate(0.631787,0.363470),rotate(105.187580),scale(1.000000,1.049772),translate(-0.631787,-0.363470)",
    id: "radialGradient-fx7mjjbv2s-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F69CE0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E15AB6",
    offset: "39.4865023%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8237F2",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 5128300,
    transform: "translate(-213.000000, -220.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(213.715000, 220.485000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.525,0 L32.515,84.778 C35.719,82.392 39.108,80.242 42.654,78.346 L54.324,16.553 L213.293,153.26 L15.416,222.579 L19.335,201.826 C16.738,198.792 14.364,195.562 12.235,192.162 L3.98,235.877 L230.528,156.515 L48.525,0",
    id: "Fill-540",
    fill: "#AAF8FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-539",
    transform: "translate(0.000000, 68.870000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-fx7mjjbv2s-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-fx7mjjbv2s-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-538"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.188,80.594 C161.188,125.104 125.105,161.187 80.594,161.187 C36.083,161.187 -2.84217094e-14,125.104 -2.84217094e-14,80.594 C-2.84217094e-14,36.083 36.083,0 80.594,0 C125.105,0 161.188,36.083 161.188,80.594",
    id: "Fill-537",
    fill: "url(#radialGradient-fx7mjjbv2s-3)",
    mask: "url(#mask-fx7mjjbv2s-2)"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapes);
export default __webpack_public_path__ + "static/media/shapes.8526569c0fc16667443e4b55be02dbca.svg";
export { ForwardRef as ReactComponent };